<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>常量值</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.enumCode" placeholder="请选择常量类型" filterable>
					<el-option key="" label="请选择" value=""></el-option>
					<el-option v-for="item in enumKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>
				&nbsp;&nbsp;
                <el-input v-model="query.value" placeholder="请输入常量值" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-download" @click="handleExport" v-if="controll['export']">导出</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="enumName" label="常量类型"></el-table-column>
                <el-table-column prop="value" label="值"></el-table-column>
				<el-table-column prop="content" label="内容"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				 <el-form-item label="常量类型" prop="enumCode">
					<el-select v-model="form.enumCode" placeholder="请选择常量类型">
						<el-option key="" label="请选择" value=""></el-option>
						<el-option v-for="item in enumKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="常量值" prop="value">
                    <el-input v-model="form.value"></el-input>
                </el-form-item>
                <el-form-item label="内容">
					<el-input type=textarea :rows=3 v-model="form.content"> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchEnumValueData, saveEnumValue, deleteEnumValue, getEnumValue, getEnumKV, exportEnumValue } from '../../../api/index';
export default {
    name: 'enum-value',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			enumKV:[],
			title:"",
			rules: {
                enumCode: [{ required: true, message:'请选择常量类型', trigger: 'blur' }],
                value: [{ required: true, message: '请输入常量值', trigger: 'blur' }]
            },
			controll:{}
        };
    },
    created() {
		this.controll = getControll("enum-value");
        this.getData();
		this.getEnums();
    },
    methods: {
		getEnums() {
			getEnumKV().then(res => {
				if (res.code == 0) {
					this.enumKV = res.data;
				} else {
					this.$message.error("获取常量类型失败！" + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchEnumValueData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteEnumValue([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteEnumValue(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            //this.form = row;
			this.title = "编辑";
			getEnumValue(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveEnumValue(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleExport() {
			exportEnumValue().then(res => {
				if (res.code == 0) {
					this.$message.success(`生成XML数据成功！`);
					var linkTag = document.createElement("a");
					linkTag.href = "/blob/export/download-xml?key=" + res.data;			
					linkTag.click();
					linkTag.remove();
				} else {
					this.$message.error(`导出失败！` + res.message);
				}
			})
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
